// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { REGULAR_TYPE, TOP_RATED_TYPE } from '@tcp/core/src/constants/badge.constants';

const isRegularOrTopRatedBadge = (props) =>
  props.type === REGULAR_TYPE || props.type === TOP_RATED_TYPE;

const getBrandSpecificColor = (props) => {
  const brandColorMap = {
    gym: props.theme.colorPalette.orange[900],
    snj: props.theme.colorPalette.purple[900],
    pjp: props.theme.colorPalette.blue[1200],
    default: props.theme.colorPalette.blue[800],
  };
  return brandColorMap[props.theme.brand] || brandColorMap.default;
};

const getBrandSpecificTopRatedBGColor = (props) => {
  const brandColorMap = {
    gym: props.theme.colorPalette.orange[800],
    snj: props.theme.colorPalette.red[300],
    pjp: props.theme.colorPalette.blue[2200],
    default: props.theme.colorPalette.blue[700],
  };
  return brandColorMap[props.theme.brand] || brandColorMap.default;
};

const getBorder = (props) => {
  if (isRegularOrTopRatedBadge(props)) {
    return 'none';
  }

  return `1px solid ${getBrandSpecificColor(props)}`;
};

const getTextColor = (props) => {
  if (isRegularOrTopRatedBadge(props)) {
    return props.theme.colors.WHITE;
  }

  return getBrandSpecificColor(props);
};

const getBackground = (props) => {
  if (props.type === REGULAR_TYPE) {
    return props.theme.colorPalette.red[500];
  }

  if (props.type === TOP_RATED_TYPE) {
    return getBrandSpecificTopRatedBGColor(props);
  }

  return props.theme.colors.WHITE;
};

export const BadgeContainer = styled.div`
  border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  border: ${(props) => getBorder(props)};
  padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS}
    ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
  background: ${(props) => getBackground(props)};
  display: flex;
  align-items: center;
`;

export const BadgeText = styled(BodyCopy)`
  color: ${(props) => getTextColor(props)};
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy_small}px;
  font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
  text-transform: uppercase;
  white-space: nowrap;

  @media ${(props) => props.theme.mediaQuery.large} {
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy1}px;
  }
`;

export const ZoneOneBadgesWrapper = styled.div`
  display: flex;
  column-gap: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  height: ${(props) => props.theme.spacing.ELEM_SPACING.REG};
  margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  max-width: 100%;
  overflow: hidden;

  @media ${(props) => props.theme.mediaQuery.large} {
    column-gap: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    height: 17px;
  }
`;
